import { gql } from '@apollo/client'
import { useMutation } from '@apollo/client/react'
import {
  UpdateTorchApplicationProjectMutation,
  UpdateTorchApplicationProjectMutationVariables,
} from '@/types/codegen-federation'

const UPDATE_TORCH_APPLICATION_PROJECT = gql`
  mutation updateTorchApplicationProject($input: UpdateTorchApplicationProjectInput) {
    updateTorchApplicationProject(input: $input)
  }
`

export const useUpdateTorchApplicationProject = () => {
  return useMutation<UpdateTorchApplicationProjectMutation, UpdateTorchApplicationProjectMutationVariables>(
    UPDATE_TORCH_APPLICATION_PROJECT,
    {
      errorPolicy: 'all',
    },
  )
}
